import { render, staticRenderFns } from "./page-panel.vue?vue&type=template&id=6b389362"
import script from "./page-panel.vue?vue&type=script&lang=js"
export * from "./page-panel.vue?vue&type=script&lang=js"
import style0 from "./page-panel.vue?vue&type=style&index=0&id=6b389362&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\abroad-hrms-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b389362')) {
      api.createRecord('6b389362', component.options)
    } else {
      api.reload('6b389362', component.options)
    }
    module.hot.accept("./page-panel.vue?vue&type=template&id=6b389362", function () {
      api.rerender('6b389362', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page-panel/page-panel.vue"
export default component.exports